import { firstQueryValue } from "~/utils/firstQueryValue";

// Same-site relative path only. Guards any query-param-sourced redirect
// target before it reaches navigateTo/window.location — a bare string cast
// of route.query lets a crafted `?redirect=https://evil.com` or `//evil.com`
// navigate off-site post-login. Array-shaped queries resolve via firstQueryValue;
// backslashes and control characters are rejected too.
export function safeReturnTo(raw: unknown): string | undefined {
  const value = firstQueryValue(raw as Parameters<typeof firstQueryValue>[0]);
  if (!value) return undefined;
  return value.startsWith("/") &&
    !value.startsWith("//") &&
    !value.includes("\\") &&
    !/\p{Cc}/u.test(value)
    ? value
    : undefined;
}
